import {AuthPasswordPatternType} from '../constants';
import {getPasswordPatternObject} from './getPasswordPatternObject';
import {getMinimumPasswordLength} from './getMinimumPasswordLength';

export type GetPasswordPatternTextParams = {
	ignoreLengthRequirement?: boolean;
};

export const getPasswordPatternText = ({
	ignoreLengthRequirement,
}: GetPasswordPatternTextParams = {}) => {
	const passwordLength = getMinimumPasswordLength();

	const passwordPatternObject = getPasswordPatternObject();

	const strings = (
		ignoreLengthRequirement ? [] : [`${passwordLength} characters`]
	).concat(
		Object.entries(passwordPatternObject || {}).reduce<string[]>(
			(accum, [patternType, patternLength]) => {
				switch (patternType) {
					case AuthPasswordPatternType.LOWERCASE_LETTERS:
						return [
							...accum,
							i18n.t('i18n.passwordLowercaseCount', {count: patternLength}),
						];
					case AuthPasswordPatternType.NUMBER:
						return [
							...accum,
							i18n.t('i18n.passwordNumberCount', {count: patternLength}),
						];
					case AuthPasswordPatternType.UPPERCASE_LETTERS:
						return [
							...accum,
							i18n.t('i18n.passwordUppercaseCount', {count: patternLength}),
						];
					case AuthPasswordPatternType.SPECIAL_CHARACTERS:
						return [
							...accum,
							i18n.t('i18n.passwordSpecialCount', {count: patternLength}),
						];
				}
				return accum;
			},
			[],
		),
	);

	return strings.length
		? `${i18n.t('i18n.passwordStrict')} ${strings.join(', ')}`
		: undefined;
};

export default getPasswordPatternText;
